export default "__VITE_ASSET__BC8bs3ER__"